export const comments_4987550 = {"data":{"data":[],"links":{}}}